<template>
  <v-btn @click="handleButtonClick" color="white" prepend-icon="mdi-plus">
    <span>{{ message }}</span>
    <AlertDialog ref="alertDialog"/>
    <UpsertIconSearchDialog ref="upsertIconSearchDialog" 
        :selectedInventoryType="this.selectedInventoryType"
    />
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex';
import AlertDialog from './AlertDialog.vue';
import UpsertIconSearchDialog from './UpsertIconSearchDialog.vue';

export default {
    components: {
      AlertDialog,
      UpsertIconSearchDialog
    },
    props: ["message", "selectedInventoryType"],
    computed: {
        ...mapGetters([
        "islegacy",
        "organizationitems",
        "workspaceid",
        "organizationid",
        ]),
    },
    emits: ['iconSaveSuccess'],
    methods: {
        handleButtonClick() {
            const result = this.$refs.upsertIconSearchDialog.open(this.message, 'Use the search bar to find an icon, or select one from the list.', {width: 600}); //this.iconUri, 
                result.then(async (choice) => {
                    if (choice === 'confirm') {
                        await this.$refs.alertDialog.showDialog('Icon Set', 'The icon has been set for the "' + this.selectedInventoryType.description + '" inventory type.', '$success');
                        this.$emit('iconSaveSuccess');
                    } else if (choice === 'cancel') {
                        console.log('User clicked cancel. Icon selection cancelled.');
                    }
                })
                .catch((e) => {
                    if (e.response.status !== 500) {
                        this.$store.dispatch("showError", "Setting inventory type icon failed: " + (e.response.data.message ?? e.response.data));
                        return;
                    }
                    this.$store.dispatch("showError", "Setting inventory type icon failed: Unknown server error.");
                })
                .finally(() => {
                    this.$store.dispatch("setLoading", false);
                });
        }
    }
}
</script>